import type { DataTableColumn } from '@/components/custom/erp';
import type { BoPhan } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<BoPhan>[] => {
  return [
    {
      field: 'ma_bp',
      headerName: 'Mã bộ phận',
      width: 150,
      editable: false
    },
    {
      field: 'ten_bp',
      headerName: 'Tên bộ phận',
      width: 300,
      flex: 1,
      editable: false
    }
  ];
};
